import {combineReducers} from "redux";
import {reducer as stocks} from "./components/stocks/stocksActions";
import {reducer as singleStock} from "./components/stocks/singleStockActions";
import {reducer as singleAuthor} from "./components/author/singleAuthorActions";
import {reducer as userIdentity} from "./userIdentityActions";
import {reducer as subscriptions} from "./components/subscription/subscriptionActions";
import {reducer as ideaDetails} from "./components/idea/ideaActions";
import {reducer as portfolios} from "./components/ourprogramme/ourProgrammeActions";
import {reducer as portfolioHealth} from "./components/ourprogramme/portfolio/portfolioActions";
import {reducer as explore} from "./components/ourprogramme/explore/exploreActions";
import {reducer as companyExplore} from "./components/ourprogramme/company/companyExploreActions";
import {reducer as company} from "./components/ourprogramme/company/companyActions";
import {reducer as activeInDevFeatures} from "./features/ActiveInDevFeaturesReducers";
import {reducer as sectorSummaries} from "./components/activity/sectors/sectorsActions";
import {reducer as notifications} from "./components/notification/notificationActions";
import {reducer as authorDetails} from "./components/contribute/homepage/authorActions";
import {reducer as stockChart} from "./components/stocks/data/stockChartActions.js";
import {reducer as portfolioAuthor} from "./components/contribute/portfolioauthor/portfolioAuthorActions";
import {reducer as settings} from "./components/app/header/settings/settingsActions";
import {reducer as clock} from "./clockActions";
import {reducer as systemBroadcastMessage} from "./systemBroadcastMessageActions";
import {reducer as helpVideos} from "./components/help/helpVideosActions";

const combinedReducers = combineReducers({
    userIdentity,
    stocks,
    singleStock,
    stockChart,
    singleAuthor,
    subscriptions,
    ideaDetails,
    notifications,
    activeInDevFeatures,
    sectorSummaries,
    portfolios,
    portfolioHealth,
    explore,
    companyExplore,
    company,
    authorDetails,
    portfolioAuthor,
    settings,
    clock,
    systemBroadcastMessage,
    helpVideos
});

export const INITIAL_STATE = combinedReducers(undefined, { type: "__GET_INITIAL_STATE" });

export default combinedReducers;
